import axios from '@/util/axios'
import axiosNoError from '@/util/axios_no_error'
import { NEW_API_CONFIG } from '@/util/constants'
import { isFromAdminSystem } from '@/util/common'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * 閲覧履歴一覧
 */
export const list = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  if (isFromAdminSystem()) {
    return axiosNoError.create(NEW_API_CONFIG).post('/BH/001', r).catch(handleError)
  } else {
    return newAxios.post('/BH/001', r).catch(handleError)
  }
}

/**
 * 閲覧履歴一覧件数取得API
 */
export const count = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  if (isFromAdminSystem()) {
    return axiosNoError.create(NEW_API_CONFIG).post('/BH/002', r).catch(handleError)
  } else {
    return newAxios.post('/BH/002', r).catch(handleError)
  }
}

/**
 * 閲覧履歴削除
 */
export const remove = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  if (isFromAdminSystem()) {
    return axiosNoError.create(NEW_API_CONFIG).post('/BH/003', r).catch(handleError)
  } else {
    return newAxios.post('/BH/003', r).catch(handleError)
  }
}
